/** * * Asynchronously loads the component for
SingleNetworkSelection
* */ import { lazyLoad } from "utils/loadable";
export const SingleNetworkSelection = lazyLoad(
  () => import("./index"),
  (module) => module.SingleNetworkSelection
);
